import React from "react";

import { Dropdown } from "./Dropdown";
import { T } from "./LanguageCurrency.tlocale";

export interface LanguageCurrencyItem {
  value: string;
  label: string;
}

export interface LanguageCurrencyProps {
  languages: LanguageCurrencyItem[];
  language: string;
  onLanguageChange: (v: string) => void;

  currencies: LanguageCurrencyItem[];
  currency: string;
  onCurrencyChange: (v: string) => void;
}

export const LanguageCurrency = React.forwardRef<HTMLDivElement, LanguageCurrencyProps>((props, ref) => (
  <div ref={ref} className="border border-line drop-shadow-only-3 bg-white p-6 space-y-6 w-64">
    <Dropdown label={T("Language")} items={props.languages} value={props.language} onChange={props.onLanguageChange} />
    <Dropdown label={T("Currency")} items={props.currencies} value={props.currency} onChange={props.onCurrencyChange} />
  </div>
));
